/**
 * Search Synonym Expander + Smart Banner — onautica.com
 * Intercepts search queries, expands with synonyms, boosts results,
 * and shows smart "not found" banners with WhatsApp CTA + alternatives.
 * Synonyms stored in shop metafield, loaded via Liquid.
 */
(function() {
  'use strict';

  var WHATSAPP_NUMBER = '393479377020';

  // Load synonym data from the inline JSON block
  var dataEl = document.getElementById('onautica-search-synonyms');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

  var synonymMap = data.synonyms || {};
  var redirects = data.redirects || [];
  var bannerMap = data.banners || {};

  // ─── UTILITY ───

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Expand a search query using synonyms
  // Supporta: (1) match esatto, (2) match multi-parola (es. "parabordo posteriore",
  // "copri salvagente") espandendo la parola/frase che corrisponde a un sinonimo.
  function expandQuery(query) {
    var q = query.trim().toLowerCase();

    // Skip if already contains OR (user manually typed it or gia espanso)
    if (q.indexOf(' or ') !== -1) return { expanded: query, changed: false };

    // 1. Match esatto: l'intera query e un termine sinonimo
    if (synonymMap[q]) {
      return { expanded: synonymMap[q].join(' OR '), changed: true };
    }

    // 2. Match multi-parola: cerca n-grammi (frasi piu lunghe prima) che
    //    corrispondono a un gruppo sinonimi, senza sovrapporre le parole gia usate.
    var words = q.split(/\s+/).filter(function(w){ return w.length > 0; });
    if (words.length > 1) {
      var used = [];
      for (var z = 0; z < words.length; z++) used.push(false);
      var addTerms = [];
      var matched = false;

      var maxN = Math.min(3, words.length);
      for (var n = maxN; n >= 1; n--) {
        for (var i = 0; i + n <= words.length; i++) {
          // salta se una parola della finestra e gia stata usata
          var overlap = false;
          for (var k = i; k < i + n; k++) { if (used[k]) { overlap = true; break; } }
          if (overlap) continue;

          var gram = words.slice(i, i + n).join(' ');
          // ignora parole troppo corte come singolo termine (es. "di", "il")
          if (n === 1 && gram.length < 3) continue;

          if (synonymMap[gram]) {
            for (var k2 = i; k2 < i + n; k2++) used[k2] = true;
            matched = true;
            var group = synonymMap[gram];
            for (var g = 0; g < group.length; g++) {
              if (group[g] !== gram) addTerms.push(group[g]);
            }
          }
        }
      }

      if (matched && addTerms.length > 0) {
        // dedup
        var seen = {}; var uniq = [];
        for (var u = 0; u < addTerms.length; u++) {
          var t = addTerms[u];
          if (!seen[t]) { seen[t] = 1; uniq.push(t); }
        }
        // Mantiene la query originale + aggiunge i sinonimi in OR
        var expanded = query + ' OR ' + uniq.join(' OR ');
        return { expanded: expanded, changed: true };
      }
    }

    // Nessun match — ritorna originale
    return { expanded: query, changed: false };
  }

  // ─── SINGOLARE / PLURALE (italiano) ───
  // La ricerca Shopify riconosce singolare e plurale solo in inglese, francese e
  // spagnolo: in italiano "morsetti" NON trova "Morsetto Gommato...". Qui la query
  // viene riscritta in forma "(parola OR variante)".
  // ATTENZIONE: la riscrittura si applica SOLO quando la ricerca grezza rende pochi
  // risultati (< PLURAL_MIN_RESULTS). Verificato dal vivo 05/08/2026: su parole larghe
  // la forma OR allarga moltissimo (cima 42 -> 359, luce 241 -> 571) perche' Shopify
  // esce dalla sua ricerca "tarata" e passa a un match booleano grezzo su tutti i
  // campi, body compreso. Sopra soglia quindi non si tocca NULLA: le ricerche che
  // gia funzionano restano identiche.
  var PLURAL_MIN_RESULTS = 10;
  var PLURAL_BLOCK = ["adeco","advance","alice","aqua","ariasana","armando","barca","barche","base","blue","bonetto","bravo","brite","bruce","brunasso","bucchi","carcano","castro","cavalieri","ceredi","cinghiale","cobra","corde","divisione","easysea","edizioni","elettronica","elica","eliche","energia","enrico","evinrude","exide","foresti","forma","frangente","fratelli","furuno","gianneschi","giorgio","guidi","honda","igloo","industrie","iosso","italia","italvipla","jabsco","jobe","lahnakoski","lenco","line","linea","liverani","lombarde","lowrance","majoni","manuale","mapa","marco","mare","marine","masnata","matromarine","mavi","monteisola","musto","nautica","nautico","nawa","nuova","onautica","osculati","penta","plastiche","plastimo","polipodio","rade","radice","raymarine","reya","riviera","roca","rocna","rule","safe","savoretti","scoprega","seaflo","selva","serie","sidermarine","sika","soragni","southco","spade","suardi","suzuki","tecma","tecno","tersma","tesa","tessilmare","tiki","tkline","tohatsu","ultra","ultramarine","varta","veco","velcro","veleria","veneziani","viadana","vileda","vitrifrigo","volpi","volvo","watersnake","wave","webasto","whale","yamaha","zucchini"];
  // {forma scritta: forma canonica} — costruita al deploy dai titoli a catalogo (11/09/2026)
  var PLURAL_CANON = {"anodi":"anodo","cartucce":"cartuccia","filtri":"filtro","smalti":"smalto","cinghie":"cinghia","lunghi":"lungo","neri":"nero","fanali":"fanale","acque":"acqua","elettrici":"elettrico","pompe":"pompa","gommone":"gommoni","raccordi":"raccordo","multiplo":"multipli","grillo":"grilli","zincati":"zincato","interruttore":"interruttori","terminale":"terminali","classico":"classici","vele":"vela","pannelli":"pannello","portello":"portelli","finiture":"finitura","sentine":"sentina","parabordi":"parabordo","tondi":"tondo","ricambi":"ricambio","luci":"luce","prese":"presa","spina":"spine","cilindrico":"cilindrici","rulli":"rullo","fori":"foro","puleggia":"pulegge","imbarcazione":"imbarcazioni","stucchi":"stucco","rapidi":"rapido","supporti":"supporto","ruote":"ruota","tappi":"tappo","laterali":"laterale","modulari":"modulare","cavi":"cavo","cime":"cima","colorati":"colorato","fusi":"fuso","tubi":"tubo","ancore":"ancora","cerniere":"cerniera","impermeabili":"impermeabile","porte":"porta","impianti":"impianto","alte":"alta","motore":"motori","marini":"marino","resistenti":"resistente","caricabatteria":"caricabatterie","interni":"interno","esterno":"esterni","idraulici":"idraulico","ganci":"gancio","valvole":"valvola","carrello":"carrelli","quadri":"quadro","metro":"metri","bordi":"bordo","riparazione":"riparazioni","bozzelli":"bozzello","tessuti":"tessuto","fissaggi":"fissaggio","comandi":"comando","compatibili":"compatibile","professionali":"professionale","carte":"carta","nere":"nero","innesto":"innesti","boccole":"boccola","sfere":"sfera","posizione":"posizioni","perni":"perno","vernici":"vernice","scaletta":"scalette","pieghevoli":"pieghevole","piastre":"piastra","remi":"remo","arco":"archi","capottine":"capottina","colore":"colori","batteria":"batterie","cursore":"cursori","serbatoio":"serbatoi","adattatori":"adattatore","tendalino":"tendalini","carene":"carena","barre":"barra","piane":"piana","panni":"panno","servizio":"servizi","fermaporte":"fermaporta"};

  function canonicalizeQuery(query) {
    if (!query) return query;
    if (query.indexOf('*') !== -1 || query.indexOf('(') !== -1 || query.indexOf('"') !== -1 ||
        query.indexOf(':') !== -1 || / (OR|AND|NOT) /.test(query)) return query;
    var ws = query.trim().split(/\s+/);
    if (ws.length > 5) return query;
    var changed = false;
    var out = ws.map(function (w) {
      var lw = w.toLowerCase();
      var c = PLURAL_CANON[lw];
      if (c && c !== lw) { changed = true; return c; }
      return w;
    });
    return changed ? out.join(' ') : query;
  }

  // Varianti singolare/plurale di UNA parola (max 3). Le forme sbagliate non fanno
  // danno: semplicemente non corrispondono a nessun prodotto.
  function pluralVariants(w) {
    var v = [];
    var s = w.slice(0, -1), e = w.slice(-1);
    var s2 = w.slice(0, -2), e2 = w.slice(-2);
    var s3 = w.slice(0, -3), e3 = w.slice(-3);
    function add(x) { if (x && x !== w && v.indexOf(x) === -1) v.push(x); }
    if (e === 'o') {
      if (e2 === 'io') add(s2 + 'i');                                  // ecoscandaglio -> ecoscandagli
      else if (e2 === 'co') { add(s2 + 'chi'); add(s2 + 'ci'); }        // banco -> banchi / amico -> amici
      else if (e2 === 'go') { add(s2 + 'ghi'); add(s2 + 'gi'); }
      else add(s + 'i');                                               // morsetto -> morsetti
    } else if (e === 'a') {
      if (e3 === 'cia' || e3 === 'gia') { add(s3 + e3.charAt(0) + 'e'); add(s3 + e3.charAt(0) + 'ie'); }
      else if (e2 === 'ca') add(s2 + 'che');                           // barca -> barche
      else if (e2 === 'ga') add(s2 + 'ghe');
      else add(s + 'e');                                               // cima -> cime
    } else if (e === 'e') {
      if (e3 === 'che') add(s3 + 'ca');
      else if (e3 === 'ghe') add(s3 + 'ga');
      else { add(s + 'i'); add(s + 'a'); }                             // timone -> timoni / cime -> cima
    } else if (e === 'i') {
      if (e3 === 'gli') { add(w + 'o'); add(s + 'o'); }                // ecoscandagli -> ecoscandaglio
      else if (e3 === 'chi') { add(s3 + 'co'); add(w + 'o'); }
      else if (e3 === 'ghi') { add(s3 + 'go'); add(w + 'o'); }
      else { add(s + 'o'); add(s + 'e'); }                             // morsetti -> morsetto
    }
    return v.slice(0, 3);
  }

  function expandPlural(query) {
    if (!query) return query;
    // Query gia' "tecnica" (jolly, booleani, virgolette): non si tocca
    if (query.indexOf('*') !== -1 || query.indexOf('(') !== -1 ||
        query.indexOf('"') !== -1 || / (OR|AND|NOT) /.test(query)) return query;
    var ws = query.trim().split(/\s+/);
    if (ws.length > 5) return query;
    var changed = false;
    var out = [];
    for (var i = 0; i < ws.length; i++) {
      var w = ws[i], lw = w.toLowerCase();
      // niente codici/misure/numeri, niente parole corte, niente nomi di marca
      if (w.length < 4 || !/^[a-zàèéìòóù]+$/i.test(w) || PLURAL_BLOCK.indexOf(lw) !== -1) { out.push(w); continue; }
      var v = pluralVariants(lw);
      if (!v.length) { out.push(w); continue; }
      changed = true;
      out.push('(' + lw + ' OR ' + v.join(' OR ') + ')');
    }
    return changed ? out.join(' ') : query;
  }

  // Rimette a video la query scritta dal cliente al posto di quella riscritta
  function restoreQueryText(shown, real) {
    if (!shown || !real || shown === real) return;
    try {
      if (document.title.indexOf(shown) !== -1) document.title = document.title.split(shown).join(real);
      var inputs = document.querySelectorAll('input[name="q"]');
      for (var i = 0; i < inputs.length; i++) inputs[i].value = real;
      var root = document.querySelector('main') || document.body;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var nodes = [], n;
      while ((n = walker.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf(shown) !== -1) nodes.push(n); }
      for (var j = 0; j < nodes.length; j++) nodes[j].nodeValue = nodes[j].nodeValue.split(shown).join(real);
    } catch (e) {}
  }

  // Ricostruisce la query del cliente da una gia' riscritta: "(a OR b) inox" -> "a inox"
  function collapseExpanded(query) {
    return query.replace(/\(([^\s)]+)(?:\s+OR\s+[^)]*)?\)/g, '$1');
  }

  // Check if query matches a redirect
  function checkRedirect(query) {
    var q = query.trim().toLowerCase();
    // First pass: exact matches (higher priority)
    for (var i = 0; i < redirects.length; i++) {
      if (!redirects[i].match && q === redirects[i].cerca) {
        return redirects[i].url;
      }
    }
    // Second pass: partial matches and contains
    for (var i = 0; i < redirects.length; i++) {
      var r = redirects[i];
      if (r.match === 'partial') {
        // SOLO forward: la query DEVE contenere il termine redirect.
        // (Il match inverso causava bug: "parabordo" e contenuto in "copriparabordo"
        //  -> "parabordi" finiva sui copriparabordi.)
        if (q.indexOf(r.cerca) !== -1) {
          return r.url;
        }
      } else if (q.indexOf(r.cerca) !== -1) {
        return r.url;
      }
    }
    return null;
  }

  // Check if query matches a banner mapping
  function checkBanner(query) {
    var q = query.trim().toLowerCase();
    // Exact match first
    if (bannerMap[q]) return bannerMap[q];
    // Partial match: check if query contains a banner term
    var keys = Object.keys(bannerMap);
    for (var i = 0; i < keys.length; i++) {
      if (q.indexOf(keys[i]) !== -1 || keys[i].indexOf(q) !== -1) {
        return bannerMap[keys[i]];
      }
    }
    return null;
  }

  // ─── A. INTERCEPT SEARCH FORM SUBMISSIONS ───

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;

    // Check redirects first
    var redirect = checkRedirect(input.value);
    if (redirect) {
      e.preventDefault();
      window.location.href = redirect;
      return;
    }

    // NB: nessuna espansione sinonimi qui. La ricerca full-text di Shopify e gia ottima;
    //     espandere in "A OR B OR C" riduceva i risultati. I sinonimi ora fanno da FALLBACK
    //     solo quando la ricerca da 0 risultati (vedi initSearchPage).
  }, true); // capture phase

  // ─── B. (rimosso) intercettazione ricerca predittiva ───
  //     L'espansione OR sulla suggest.json era controproducente; usiamo la predittiva nativa.

  console.log('[Onautica] Search Enhancer attivo —', Object.keys(synonymMap).length, 'termini (modalita fallback)');

  // ─── C. BOOST SEARCH RESULTS ───

  var boostEl = document.getElementById('onautica-search-boost');
  if (boostEl && window.location.pathname.indexOf('/search') !== -1) {
    try {
      var boostData = JSON.parse(boostEl.textContent);
      var scores = boostData.scores || {};

      function reorderResults() {
        var grid = document.getElementById('product-grid');
        if (!grid) return;
        var items = Array.prototype.slice.call(grid.querySelectorAll('.grid-item'));
        if (items.length < 2) return;

        // Ordine (regola di Daniele, 11/09/2026): prima i prodotti A MAGAZZINO, poi quelli
        // in DROPSHIP, in fondo i non disponibili (data-disp scritto da sections/main-search
        // .liquid con lo snippet onautica-disp). Dentro ogni gruppo: best seller (boost)
        // e poi la pertinenza di Shopify, cioè l'ordine in cui il risultato è arrivato.
        var scored = items.map(function(item, idx) {
          var link = item.querySelector('a.js-product-link');
          var handle = '';
          if (link) {
            var parts = link.getAttribute('href').split('/products/');
            if (parts[1]) handle = parts[1].split('?')[0].split('#')[0];
          }
          if (item._idx === undefined) item._idx = idx;
          var disp = item.hasAttribute('data-disp') ? parseInt(item.getAttribute('data-disp'), 10) : -1;
          return { el: item, score: scores[handle] || 0, disp: isNaN(disp) ? -1 : disp, idx: item._idx };
        });

        scored.sort(function(a, b) { return b.disp - a.disp || b.score - a.score || a.idx - b.idx; });

        // niente da spostare = niente mutazioni (l'observer qui sotto rilancerebbe all'infinito)
        var giaInOrdine = scored.every(function(s, i) { return s.el === items[i]; });
        if (giaInOrdine) return;

        for (var i = 0; i < scored.length; i++) {
          grid.appendChild(scored[i].el);
        }
        console.log('[Onautica] Search Boost attivo — riordinati', items.length, 'risultati (magazzino → dropship → non disponibile)');
      }

      reorderResults();

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length > 0) {
            setTimeout(reorderResults, 100);
            return;
          }
        }
      });
      var container = document.getElementById('ProductGridContainer');
      if (container) observer.observe(container, { childList: true, subtree: true });
    } catch(e) {}
  }

  // ─── D. SMART BANNER "NON TROVATO" ───

  function showSmartBanner(query, bannerData) {
    // Segna che il banner smart e attivo (il tracker non mostra Avvisami)
    window.__onauticaSmartBanner = true;

    // Rimuovi eventuali banner precedenti
    var existing = document.getElementById('onautica-smart-banner');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.id = 'onautica-smart-banner';
    banner.style.cssText = [
      'max-width:720px',
      'margin:24px auto',
      'background:linear-gradient(135deg,#f0f7ff 0%,#e8f0fe 100%)',
      'border:2px solid #1a56db',
      'border-radius:16px',
      'padding:28px 32px',
      'font-family:Arial,Helvetica,sans-serif',
      'box-shadow:0 4px 24px rgba(26,86,219,0.12)',
      'position:relative',
      'animation:onauticaBannerIn 0.4s ease'
    ].join(';');

    // Animazione entrata
    if (!document.getElementById('onautica-banner-style')) {
      var style = document.createElement('style');
      style.id = 'onautica-banner-style';
      style.textContent = '@keyframes onauticaBannerIn{from{opacity:0;transform:translateY(-12px)}to{opacity:1;transform:translateY(0)}}';
      document.head.appendChild(style);
    }

    var whatsappText = encodeURIComponent('Ciao! Cerco ' + query + ' per la mia barca. Potete aiutarmi?');
    var whatsappUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + whatsappText;

    var html = '' +
      '<div style="text-align:center;margin-bottom:20px;">' +
        '<div style="font-size:36px;margin-bottom:8px;">\uD83D\uDD0D</div>' +
        '<h3 style="font-size:20px;font-weight:700;color:#1a56db;margin:0 0 8px;">Non abbiamo trovato "' + escapeHtml(query) + '"</h3>' +
        '<p style="color:#444;font-size:15px;margin:0;line-height:1.5;">' + escapeHtml(bannerData.messaggio) + '</p>' +
      '</div>' +
      '<div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;">' +
        '<a href="' + whatsappUrl + '" target="_blank" rel="noopener" style="' +
          'display:inline-flex;align-items:center;gap:8px;' +
          'background:#25D366;color:#fff;' +
          'padding:14px 28px;border-radius:12px;' +
          'font-size:15px;font-weight:700;' +
          'text-decoration:none;' +
          'transition:transform 0.15s,box-shadow 0.15s;' +
          'box-shadow:0 2px 8px rgba(37,211,102,0.3);' +
        '" onmouseover="this.style.transform=\'scale(1.03)\';this.style.boxShadow=\'0 4px 16px rgba(37,211,102,0.4)\'" ' +
        'onmouseout="this.style.transform=\'scale(1)\';this.style.boxShadow=\'0 2px 8px rgba(37,211,102,0.3)\'">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
          'Chiedi a noi' +
        '</a>';

    // Aggiungi bottone alternative solo se c'e una collezione mappata
    if (bannerData.collezione) {
      html += '' +
        '<a href="/collections/' + escapeHtml(bannerData.collezione) + '" style="' +
          'display:inline-flex;align-items:center;gap:8px;' +
          'background:#1a56db;color:#fff;' +
          'padding:14px 28px;border-radius:12px;' +
          'font-size:15px;font-weight:700;' +
          'text-decoration:none;' +
          'transition:transform 0.15s,box-shadow 0.15s;' +
          'box-shadow:0 2px 8px rgba(26,86,219,0.3);' +
        '" onmouseover="this.style.transform=\'scale(1.03)\';this.style.boxShadow=\'0 4px 16px rgba(26,86,219,0.4)\'" ' +
        'onmouseout="this.style.transform=\'scale(1)\';this.style.boxShadow=\'0 2px 8px rgba(26,86,219,0.3)\'">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
          escapeHtml(bannerData.label) +
        '</a>';
    }

    html += '</div>';

    banner.innerHTML = html;

    // Inserisci nel DOM — prima dei risultati o nell'area di ricerca
    var target = document.getElementById('ProductGridContainer')
      || document.querySelector('.search-results')
      || document.querySelector('main .page-content')
      || document.querySelector('main');

    if (target) {
      target.insertBefore(banner, target.firstChild);
    } else {
      // Fallback: dopo l'header
      var main = document.querySelector('main') || document.body;
      main.insertBefore(banner, main.firstChild);
    }

    console.log('[Onautica] Smart Banner mostrato per "' + query + '"');
  }

  // ─── E. REDIRECT + BANNER ON SEARCH PAGE LOAD ───

  function initSearchPage() {
    if (window.location.pathname !== '/search') return;

    var params = new URLSearchParams(window.location.search);
    var query = params.get('q');
    if (!query || query.trim().length < 2) return;

    // Recupera la query originale (prima di qualsiasi riscrittura)
    var originalQuery = params.get('_q') || query;
    if (!params.get('_q') && query.indexOf(' OR ') !== -1) {
      // arrivo da paginazione/filtri su una query gia' riscritta: la ricostruisco
      originalQuery = query.indexOf('(') !== -1 ? collapseExpanded(query) : query.split(' OR ')[0].trim();
    }

    // Check redirect on page load (es. "normativa 2026" -> blog post)
    var redirect = checkRedirect(originalQuery);
    if (redirect) {
      window.location.replace(redirect);
      return;
    }

    // SINGOLARE = PLURALE (regola di Daniele, 11/09/2026: «ancora» e «ancore» devono dare
    // gli stessi identici risultati). Shopify in italiano non lo fa da solo, e la forma
    // «(a OR b)» oggi RESTRINGE i risultati (misurato 11/09: ancora 404 → 297, morsetti
    // 36 → 9). Quindi si sceglie UNA forma per ogni parola — quella che compare in più
    // titoli a catalogo, mappa PLURAL_CANON costruita al deploy — e la ricerca gira sempre
    // su quella: stessi risultati, stessa graduatoria nativa. La parola scritta dal
    // cliente resta a video (_q + restoreQueryText).
    if (!params.get('_pl') && !params.get('_plx') && !params.get('_syn') && !params.get('_pc')) {
      var cq = canonicalizeQuery(originalQuery);
      if (cq !== originalQuery) {
        window.__onauticaCanonRedirect = true;
        window.location.replace('/search?q=' + encodeURIComponent(cq) +
          '&type=product&_pc=1&_q=' + encodeURIComponent(originalQuery));
        return;
      }
    }

    var resultCount = countResults();

    // Rimette a video la query del cliente (il titolo serve prima a countResults)
    if (originalQuery !== query) restoreQueryText(query, originalQuery);

    // RETE DI SICUREZZA: se la forma riscritta rende MENO risultati di quella
    // scritta dal cliente, si torna indietro. Su query di piu parole il booleano
    // stringe (AND rigido) e puo far sparire risultati: il cliente non deve mai
    // vederne meno di prima.
    if (params.get('_pl')) {
      var prima = parseInt(params.get('_n') || '-1', 10);
      if (prima >= 0 && resultCount < prima) {
        window.location.replace('/search?q=' + encodeURIComponent(originalQuery) + '&type=product&_plx=1');
        return;
      }
    }

    // SINGOLARE/PLURALE: solo se la ricerca rende pochi risultati e non e gia un tentativo.
    if (resultCount < PLURAL_MIN_RESULTS && !params.get('_pl') && !params.get('_plx') && !params.get('_syn')) {
      var pq = expandPlural(originalQuery);
      if (pq !== originalQuery) {
        window.location.replace('/search?q=' + encodeURIComponent(pq) +
          '&type=product&_pl=1&_n=' + resultCount + '&_q=' + encodeURIComponent(originalQuery));
        return;
      }
    }

    // FALLBACK SINONIMI: solo se la ricerca da 0 risultati e non e gia un tentativo,
    // riprova con UN SOLO termine canonico del gruppo sinonimi (NON una catena OR,
    // che Shopify gestisce male). Cosi non rovina mai le ricerche che gia funzionano.
    if (resultCount === 0 && !params.get('_syn')) {
      var ft = bestSynonymTerm(originalQuery);
      if (ft && ft !== originalQuery.toLowerCase().trim()) {
        window.location.replace('/search?q=' + encodeURIComponent(ft) + '&type=product&_syn=1');
        return;
      }
    }

    initBanner(originalQuery, resultCount);
  }

  // Restituisce il singolo termine canonico (primo del gruppo) per il fallback, o null
  function bestSynonymTerm(query) {
    var q = query.trim().toLowerCase();
    if (q.indexOf(' or ') !== -1) return null;
    if (synonymMap[q]) return synonymMap[q][0];
    var words = q.split(/\s+/).filter(function(w){ return w.length > 0; });
    for (var n = Math.min(3, words.length); n >= 1; n--) {
      for (var i = 0; i + n <= words.length; i++) {
        var gram = words.slice(i, i + n).join(' ');
        if (n === 1 && gram.length < 3) continue;
        if (synonymMap[gram]) return synonymMap[gram][0];
      }
    }
    return null;
  }

  function countResults() {
    var rc = -1;
    var titleMatch = document.title.match(/Ricerca:\s*(\d+)\s*risultat/i);
    if (titleMatch) rc = parseInt(titleMatch[1]);
    if (rc === -1) {
      var cards = document.querySelectorAll('.product-card, .grid-product, [data-product-card], .product-item, .collection-product-card, .grid-item');
      rc = cards.length;
    }
    return rc;
  }

  function initBanner(originalQuery, resultCount) {
    var bannerData = checkBanner(originalQuery);
    if (!bannerData) return;
    if (resultCount == null) resultCount = countResults();
    // Mostra il banner solo se 0 o 1 risultato (irrilevante)
    if (resultCount < 2) {
      showSmartBanner(originalQuery, bannerData);
    }
  }

  // Run redirect + banner on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();
